/**
 * EL CÓDIGO DE TODAS LAS PANTALLAS, DESCARGADO DE ANTEMANO.
 *
 * La app se baja a trozos: cada pantalla es un fichero que se pide la primera
 * vez que se abre. Sin red, abrir una pantalla que no se abrió en esta sesión
 * fallaría —su trozo no está— aunque sus DATOS sí estén en el teléfono. Con
 * esto, la descarga completa pide también el código de todas las pantallas:
 * quedan cargadas en esta sesión y en la caché del WebView para las siguientes
 * (producción las sirve con `cache-control: immutable` de un año).
 *
 * `import.meta.glob` las enumera solas: una pantalla nueva entra sin tocar esto.
 * Fuera las de la web pública (landing), que no se usan dentro de la app.
 */

const PANTALLAS = import.meta.glob(["/src/pages/**/*.tsx", "!/src/pages/landing/**", "!/src/pages/**/*.test.tsx"]);

/** Trozos que se cargan DENTRO de una pantalla al abrir algo (fichas, capas, informes). */
const DENTRO: Array<() => Promise<unknown>> = [
  () => import("@/components/planner/TaskFormDialog"),
  () => import("@/components/planner/TreatmentProductsSection"),
  () => import("@/components/health-map/MapLayers"),
  () => import("@/components/health-map/analytics/scopeTheme"),
  () => import("@/components/blocks/ClosedCycleSummaryPanel"),
  () => import("@/components/campaigns/CampaignCycleBreakdown"),
  () => import("@/components/crops/CropVarietyFields"),
  () => import("@/components/reports/shell"),
];

let hecha = false;

/** Carga todo el código, de dos en dos. Devuelve cuántos trozos se pidieron. */
export async function precargarPantallas(): Promise<number> {
  if (hecha) return 0;
  const cargas = [...Object.values(PANTALLAS), ...DENTRO];
  let i = 0;
  const trabajador = async () => {
    while (i < cargas.length) {
      const cargar = cargas[i++];
      try {
        await cargar();
      } catch {
        /* un trozo que no baja no para los demás; se reintenta en la próxima pasada */
        return;
      }
    }
  };
  await Promise.all([trabajador(), trabajador()]);
  if (i >= cargas.length) hecha = true;
  return cargas.length;
}
